// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AppHeader = require('client-v2/common/containers/app-header/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const ArticleProfileModal = require('client-v2/common/containers/article-profile/components/modal-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
const CollectionSelectModal = require('client-v2/common/containers/collection-select-modal/component-smart')
const ConfirmModal = require('client-v2/common/containers/confirm-modal/component-smart')
const ContentAddModal = require('client-v2/common/containers/content-add-modal/component-smart')
const FeedAwareAppFooter = require('client-v2/common/containers/feed/app-footer').default
const OpenInAppButton = require('client-v2/common/containers/open-in-app-button/component-smart')
const ShareModal = require('client-v2/common/containers/share-modal/component-smart')
const Toasts = require('client-v2/common/containers/toasts/component-smart')
const LightweightEngagementTutorialModal = require('client-v2/common/containers/lightweight-engagement/containers/tutorial/modal-smart')
// Entry imports
const CollectionEditModal = require('../containers/collection-edit-modal/component-smart')
const CollectionEditCoverImageModal = require('../containers/collection-edit-cover-image-modal/component-smart')
const CollectionEditHeaderImageModal = require('../containers/collection-edit-header-image-modal/component-smart')
const CollectionProfileFeed = require('../containers/feed/component-smart')
const CollectionProfileHeader = require('../containers/header/component-smart')
const CollectionProfileNav = require('../containers/nav/component-smart')

const bem = BemEntity('CollectionProfileLayout')

function CollectionProfileLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('page')
      },
        tag(AppHeader, {
          className: bem.element('header')
        }),
        tag('div', {
          className: bem.element('body'),
          role: 'main'
        },
          tag(CollectionProfileHeader),
          tag(CollectionProfileNav),
          tag(CollectionProfileFeed)
        ),
        tag(FeedAwareAppFooter),
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      ),
      Portal.toModalRoot(
        tag(CollectionEditModal),
        tag(CollectionEditCoverImageModal),
        tag(CollectionEditHeaderImageModal),
        tag(ArticleProfileModal),
        tag(CollectionSelectModal),
        tag(ContentAddModal),
        tag(OpenInAppButton),
        tag(AuthModal),
        tag(ShareModal),
        tag(ConfirmModal),
        tag(Toasts),
        tag(LightweightEngagementTutorialModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(CollectionProfileLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  CollectionProfileLayout
})
